/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import GrayPanel from '../../../components/GrayPanel';
import s from '../Admin.css';
import PaperTile from '../../../components//PaperTile/PaperTile';
import PaperHeader from '../../../components/PaperHeader/PaperHeader';
import { fetchDistrictList } from '../../../actions/app';
import { wybierzGmine } from '../../../actions/gminy';
import { notFoundImageURL } from '../../../config';
import Link from '../../../components/Link';

const stylowo = {
  display: 'flex',
  justifyContent: 'center',
  padding: '0 20%',
};

class Districts extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    districts: PropTypes.object,
  };

  // componentWillMount() {
  //   !this.props.districts.areDistrictsFetched || !this.props.districts.districtsList ?
  //     this.props.fetchDistrictList() : null;
  // }

  render() {
    return (
      <div>
        <PaperHeader title="Dodawanie nowego urzędu" />
        <div className="row">
          <div style={stylowo} className="col-xs-12">
            <div className="col-xs-8">Przejdź do panelu dodawania nowej gminy:</div>
            <Link className="btn btn-warning col-xs-4" to={`/admin/districts/addDistrict`}>Dodaj gminę</Link>
          </div>
        </div>
        <PaperHeader title="Lista zarejestrowanych urzędów" />
        <div className="row">
          {this.props.districts && Object.keys(this.props.districts).map((v, i) =>{
              if(this.props.districts[v].showOnList) {
                return (<div key={i} className="col-xs-12 col-sm-6 col-md-4">
                <PaperTile
                  href={`/urzad/${this.props.districts[v].prefix}`}
                  text={this.props.districts[v].name}
                  herb={this.props.districts[v].herb ?
                    `https://e-spdp.pl/oldihub/upload/herby/${this.props.districts[v].herb}`
                  : notFoundImageURL
                  }
                />
                </div>)
              }
            }
          )}
        </div>
        {/* <PaperHeader title="Lista zarejestrowanych urzedów" />
        <div className="row">
          {this.props.districts.districtsList ? this.props.districts.districtsList.map((v, i) => {
            return (
              <div key={i} className="col-xs-12 col-sm-6 col-md-4">
                <PaperTile
                  href={`/admin/districts/editDistrict/${v.teryt}`}
                  text={v.name}
                  herb={v.herb ? `${process.env.OLD_IHUB}/upload/herby/${v.herb}` : notFoundImageURL}
                />
              </div>
            );
          }) : null
          }
        </div> */}
      </div>
    );
  }
}

const mapState = (state) => ({
  districts: state.district.districts,
});

const mapDispatch = {
  wybierzGmine,
};

export default withStyles(s)(connect(mapState, mapDispatch)(Districts));



// WEBPACK FOOTER //
// src/routes/admin/districts/Districts.js